import type { CouponData } from 'components/new-appointment/Coupon';
import type { Service, StaffOption } from 'types/models';
import type { NewAppointmentState } from './index.reducer';

export const REDUCER_NEW_APT_ACTIONS = {
  INIT_SHOP_DATA: 'INIT_SHOP_DATA',
  SET_CUSTOMER_INFO: 'SET_CUSTOMER_INFO',
  SET_SERVICES: 'SET_SERVICES',
  SET_STAFF_DATE: 'SET_STAFF_DATE',
  SET_TIME_SLOT: 'SET_TIME_SLOT',
  SET_NOTE: 'SET_NOTE',
  SET_GROUP_VALUE: 'SET_GROUP_VALUE',
  RESET: 'RESET',
} as const;

export interface SetCustomerInfoPayload {
  id?: string | number | null;
  phone?: string;
  name?: string;
  coupon?: CouponData | null;
}

export interface SetStaffDatePayload {
  staff: StaffOption | null;
  date: Date;
  isRequestStaff: boolean;
}

const setCustomerInfo = (state: NewAppointmentState, payload?: SetCustomerInfoPayload): NewAppointmentState => ({
  ...state,
  // SetCustomerInfoPayload's fields are individually optional (whole `payload` is
  // optional too), but NewAppointmentState.customer requires them; the sole
  // dispatcher (information.tsx) always supplies all three, so cast rather than
  // widen the shared state shape used elsewhere as required strings.
  customer: {
    phone: payload?.phone as string,
    name: payload?.name as string,
    id: payload?.id as string | number | null,
  },
  coupon: payload?.coupon || null,
});

const setServices = (state: NewAppointmentState, payload: Service[]): NewAppointmentState => ({
  ...state,
  selectedServices: payload,
});

const setStaffDate = (state: NewAppointmentState, payload: SetStaffDatePayload): NewAppointmentState => ({
  ...state,
  selectedStaff: payload.staff,
  selectedDate: payload.date,
  isRequestStaff: payload.isRequestStaff,
});

const setTimeSlot = (state: NewAppointmentState, payload: string | null): NewAppointmentState => ({
  ...state,
  timeSlot: payload,
});

const setNote = (state: NewAppointmentState, payload: string): NewAppointmentState => ({
  ...state,
  note: payload,
});

const setGroupValue = (state: NewAppointmentState, payload: number): NewAppointmentState => ({
  ...state,
  group: payload,
});

const reset = (state: NewAppointmentState): NewAppointmentState => ({
  ...state,
  customer: {
    phone: '',
    name: '',
    id: null,
  },
  coupon: null,
  selectedServices: [],
  selectedStaff: null,
  isRequestStaff: false,
  timeSlot: null,
  selectedDate: new Date(),
  note: '',
  group: 1,
})

const actions = { setCustomerInfo, setServices, setStaffDate, setTimeSlot, setNote, setGroupValue, reset };

export default actions;
